import { useState } from 'react'
import { Check, MessageSquareWarning, X } from 'lucide-react'
import type { Keuze as KeuzeBlok } from '../lib/types'

/* ===========================================================================
 *  Een situatie met een keuze
 *
 *  Na het antwoorden blijven ALLE opties staan, met bij elk waarom hij goed
 *  of fout is. Dat is met opzet: bij dit soort vragen zit de les vaak in de
 *  optie die je níét koos maar wel overwoog. Alleen "fout, probeer opnieuw"
 *  laat dat liggen.
 * =========================================================================== */

export default function Keuze({
  blok, opKlaar,
}: {
  blok: KeuzeBlok
  opKlaar: () => void
}) {
  const [gekozen, setGekozen] = useState<number | null>(null)

  function kies(i: number) {
    if (gekozen !== null) return
    setGekozen(i)
    opKlaar()
  }

  return (
    <div className="keuze">
      {blok.situatie && (
        <div className="situatie">
          <MessageSquareWarning
            size={15}
            style={{ verticalAlign: -2, marginRight: 8, color: 'var(--info)' }}
          />
          {blok.situatie}
        </div>
      )}

      <div className="vraag">{blok.vraag}</div>

      <div className="opties">
        {blok.opties.map((optie, i) => {
          const gedaan = gekozen !== null
          let klasse = 'optie'
          if (gedaan) {
            if (optie.goed) klasse += ' goed'
            else if (gekozen === i) klasse += ' mis'
            else klasse += ' flauw'
          }

          return (
            <button
              key={i}
              type="button"
              className={klasse}
              onClick={() => kies(i)}
              disabled={gedaan}
            >
              <span className="merk">
                {gedaan
                  ? (optie.goed ? <Check size={14} /> : gekozen === i ? <X size={14} /> : LETTERS[i])
                  : LETTERS[i]}
              </span>
              <span>{optie.tekst}</span>
            </button>
          )
        })}
      </div>

      {gekozen !== null && (
        <div className="opkomst" style={{ display: 'grid', gap: 10 }}>
          {blok.opties.map((optie, i) => (
            <div key={i} className={`uitslag ${optie.goed ? 'goed' : gekozen === i ? 'mis' : 'grijs'}`}>
              {optie.goed ? <Check size={16} /> : <X size={16} />}
              <span>
                <span className="titel">{LETTERS[i]} — {optie.goed ? 'dit klopt' : 'niet dit'}</span>
                {optie.uitleg}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const LETTERS = ['A', 'B', 'C', 'D', 'E']
